import {
  PRODUCT_SEARCH_RESULTS_VIEW, PRODUCT_SEARCH_RESULTS_CLEAR_FILTER,
  PRODUCT_SEARCH_RESULTS_APPLY_FILTER, PRODUCT_SEARCH_RESULTS_APPLY_SORT,
  PRODUCT_SEARCH_RESULTS_CLEAR,
} from './types';

export const triggerPsrIsViewed = (keywords) => ({
  type: PRODUCT_SEARCH_RESULTS_VIEW,
  keywords,
});

export const triggerPsrClearFilterGaEvent = () => ({
  type: PRODUCT_SEARCH_RESULTS_CLEAR_FILTER,
});

export const triggerPsrApplyFilterGaEvent = (facet, isAddedToFilter) => ({
  type: PRODUCT_SEARCH_RESULTS_APPLY_FILTER,
  facet,
  isAddedToFilter,
});

export const triggerPrsApplySortGaEvent = (sortType) => ({
  type: PRODUCT_SEARCH_RESULTS_APPLY_SORT,
  sortType,
});

export const triggerPsrClearResult = () => ({
  type: PRODUCT_SEARCH_RESULTS_CLEAR,
});
